import { defaultLocale } from "../localization/locales";

export const localizeLinkTo = (to: string, locale: string = defaultLocale) => {
	return `/${locale}/${to.startsWith("/") ? to.substring(1) : to}`;
};
